module.exports = __webpack_public_path__ + "img/es.c4976eaf.png";